document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.embla');

  sliders.forEach((slider) => {
    const viewport = slider.querySelector('.embla__viewport');

    const prevBtn = slider.querySelector('.prev');
    const nextBtn = slider.querySelector('.next');

    const dotsContainer = slider.querySelector('.slider-dots');

    const embla = EmblaCarousel(viewport, {
      loop: true,
      align: 'start',
      dragFree: false
    });

    /* -------------------- */
    /* Recalculate after images load */
    /* -------------------- */

    const images = slider.querySelectorAll('img');

    let imagesLoaded = 0;

    const onImageLoad = () => {
      imagesLoaded++;

      if (imagesLoaded >= images.length) {
        embla.reInit();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        onImageLoad();
      } else {
        img.addEventListener('load', onImageLoad);
      }
    });

    /* -------------------- */
    /* Arrows */
    /* -------------------- */

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        embla.scrollNext();
      });
    }

    /* -------------------- */
    /* Dots */
    /* -------------------- */

    if (dotsContainer) {
      const dots = embla.scrollSnapList();

      dots.forEach((_, index) => {
        const dot = document.createElement('button');

        dot.classList.add('slider-dot');

        if (index === embla.selectedScrollSnap()) {
          dot.classList.add('active');
        }

        dot.addEventListener('click', () => {
          embla.scrollTo(index);
        });

        dotsContainer.appendChild(dot);
      });

      const updateDots = () => {
        const allDots =
          dotsContainer.querySelectorAll('.slider-dot');

        allDots.forEach((dot, index) => {
          dot.classList.toggle(
            'active',
            index === embla.selectedScrollSnap()
          );
        });
      };

      embla.on('select', updateDots);

      updateDots();
    }


    window.addEventListener('resize', () => {
      embla.reInit();
    });
  });
});